/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HCircleIcon24Regular = forwardRef('UiMenuDots3HCircleIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M16.248 13.248a1.248 1.248 0 1 0 0-2.496 1.248 1.248 0 0 0 0 2.496Z" }),
        React.createElement("path", { d: "M13.248 12a1.248 1.248 0 1 1-2.496 0 1.248 1.248 0 0 1 2.496 0Z" }),
        React.createElement("path", { d: "M7.748 13.248a1.248 1.248 0 1 0 0-2.496 1.248 1.248 0 0 0 0 2.496Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0Z" })));
});
